export enum SectionType {
    Files = 'files',
    Text = 'text',
    Quiz = 'quiz',
    IntegratedQuiz = 'integrated_quiz',
    ELearning = 'e_learning',
    Survey = 'survey',
    Feedback = 'feedback_360',
    OneFile = 'one_file',
}
